import { csvw_url } from "../../components/config";
let a = {
  title: "",
  titleEn: "",
  subtitle: "",
  subtitleEn: "",
  dec: "",
  decEn: "",
  img: "",
  imgMobile: "",
  list: [],
};
let b = {
  title: "",
  titleEn: "",
  dec: "",
  decEn: "",
};
export default {
  title: "促进目标实现的伙伴关系",
  titleEn: "Partnerships for the Goal",
  btn: [
    {
      title: "供应链管理与协作",
      titleEn: "Supply Chain Management and Cooperation",
      subtitle: "",
      subtitleEn: "",
      dec:
        "上汽大众始终关注供应链的管理与发展，在采购过程中全面融入企业社会责任的考量，助力供应链健康发展，积极与合作伙伴各方开展沟通与培训，进一步提升供应链责任管理，强化供应商合作伙伴的责任意识。",
      decEn:
        "SAIC VOLKSWAGEN has always attached great importance to the management and development of the supply chain, with full consideration of corporate social responsibility in the procurement process. This enables the healthy development of the supply chain. Through active communication and training with all partners, SAIC VOLKSWAGEN further improves the management of supply chain responsibility and reinforces the awareness of responsibility among suppliers and partners.",
      img: require("../../assets/csr/imgs/Pcon1@2x.png"),
      imgMobile: require("../../assets/csr/imgsMobile/MPcon1@2x.png"),
      img2: require("../../assets/csr/imgs/Ptu1@2x.png"),
      imgMobile2: require("../../assets/csr/imgsMobile/MPtu1@2x.png"),
      list: [
        {
          title: "提升责任管理",
          titleEn: "Enhance responsible management",
          dec:
            "上汽大众建设了完善的供应商准入、评价与违规处理等机制，通过《上汽大众供应商可持续发展要求》，在供应链各环节严格落实企业社会责任嵌入，坚持诚实可信和恪守规则的行为准则，倡导供应商合作伙伴关注责任践行。",
          decEn:
            "SAIC VOLKSWAGEN has built a perfect mechanism for supplier access, evaluation and violation handling, with strict implementation of CSR in every aspect of the supply chain. Following SAIC VOLKSWAGEN Supplier Sustainability Requirements, we strictly comply with the code of conduct of honesty, credibility and adherence to rules while advocating our partner suppliers to focus on responsible practices.",
        },
        {
          title: "强化责任能力",
          titleEn: "Reinforcing responsibility",
          dec:
            "为了进一步帮助供应商明晰自身履责的重要性，提高供应商责任能力，上汽大众结合政策时事、热点趋势与社会责任理念等，对供应商进行专业的培训与考核。其中，上汽大众对于碳排放重点材料供应商组进行低碳化培训交流，推动和帮助相关供应商制定低碳化措施及计划。</br>2022年，上汽大众共开展供应商相关培训1场，共计50家供应商参与培训。通过培训，进一步加深供应商伙伴对企业社会责任的重视，持续强化品牌价值，助力供应链可持续发展。",
          decEn:
            "In order to further help suppliers understand the importance of their own responsibility and improve their capacity of fulfilling responsibility, SAIC VOLKSWAGEN conducts professional training and assessment for them, taking into account the latest policies and current affairs, popular trends and social responsibility concepts. Among these trainings, SAIC VOLKSWAGEN conducted low carbon training and communication activities for key carbon emission material groups. They helped relevant suppliers to develop low carbon measures and plans.</br>In 2022, SAIC VOLKSWAGEN conducted one supplier-related training session attended by a total of 50 suppliers. The training aimed to make our partner suppliers pay more attention to corporate social responsibility, strengthen the brand value and contribute to the sustainable development of the supply chain.",
        },
      ],
    },
    {
      title: "经销商协同发展",
      titleEn: "Coordinated Development with Dealers",
      subtitle: "",
      subtitleEn: "",
      dec:
        "上汽大众始终关注供应链的管理与发展，在采购过程中全面融入企业社会责任的考量，助力供应链健康发展，积极与合作伙伴各方开展沟通与培训，进一步提升供应链责任管理，强化供应商合作伙伴的责任意识。",
      decEn:
        "SAIC VOLKSWAGEN has always attached great importance to the management and development of the supply chain, with full consideration of corporate social responsibility in the procurement process. This enables the healthy development of the supply chain. Through active communication and training with all partners, SAIC VOLKSWAGEN further improves the management of supply chain responsibility and reinforces the awareness of responsibility among suppliers and partners.",
      img: require("../../assets/csr/imgs/Pcon2@2x.png"),
      imgMobile: require("../../assets/csr/imgsMobile/MPcon2@2x.png"),
      img2: require("../../assets/csr/imgs/Ptu2@2x.png"),
      imgMobile2: require("../../assets/csr/imgsMobile/MPtu2@2x.png"),
      img3: require("../../assets/csr/imgs/Ptu3@2x.png"),
      imgMobile3: require("../../assets/csr/imgsMobile/MPtu2@2x.png"),
      list: [
        {
          title: "经销商赋能",
          titleEn: "Empowering dealers",
          dec:
            "上汽大众关注经销商的多维度发展，开展多形式的培训与能力建设活动。公司从销售与成交、营销、服务、管理等多方面给予经销商全方位指导，助力个人能力提升与经销商整体能力提高，使“责任”二字贯穿经销商成长，推动经销商提供更优质的服务。",
          decEn:
            "SAIC VOLKSWAGEN places great emphasis on the multi-dimensional development of dealers and carries out multi-faceted training and capacity building activities. The Company provides comprehensive guidance for dealers, covering various aspects from sales and transaction, marketing, service, management and others, so as to improve individual competency and the overall capacity of dealers. Through these efforts, “responsibility” can run through the growth of dealers, driving them to provide better customer service.",
        },
        {
          title: "个人营销与服务能力提升",
          titleEn: "Individual marketing and service capability improvement",
          dec:
            "2022年，上汽大众全面优化“人员培训”，进一步提高经销人员的营销与客户服务能力，本年度大众品牌共开发53门E-learning课程，累计完成300期销售顾问、代理制销售顾问、一线关键岗位的认证培训。此外，为了让经销商伙伴进一步理解上汽大众企业社会责任理念，并将其传递给到用户，上汽大众针对经销商开展了50场线上培训，累计覆盖150,000人次。培训采用“播”与“考”结合的形式，保障一线员工对公司相关重要信息的有效掌握。",
          decEn:
            "In 2022, SAIC VOLKSWAGEN further optimized “personnel training” to strengthen the marketing and customer service skills of its sales staff. Volkswagen developed 53 E-learning courses. A total of 300 sessions of certified training for sales consultants, agency sales consultants and front-line key positions have been completed. In addition, in order to enable dealer to further understand SAIC VOLKSWAGEN's CSR philosophy and pass it on to customers, the Company conducted 50 online trainings for dealers, covering a total of 150,000 participants. The combination of “broadcast” and “examination” ensured that front-line employees could gain a good understanding of important companyrelated information.",
        },
        {
          title: "组织管理与经营能力提升",
          titleEn: "Improvement of organizational management and operational capability",
          dec:
            "2022年，上汽大众渠道管理针对经销商的业务痛点持续推进升级，帮助经销商提高在整体组织经营上的把控，持续提高管理能力。</br>上汽大众围绕CAE潜客集结、RSE卓越零售、增值业务能力提升、成交涡轮等多个方向，开展个性化辅导项目，进一步帮助经销商挖掘自身潜力，实现其更高比率的潜客触及与转化，扩充扩充经销商的私域流量池，提升经销商线上运维能力，提高管理效益。2022年，公司共计开展辅导超过1,000场。",
          decEn:
            "In terms of improvement of organizational capacity, SAIC VOLKSWAGEN’s channel management department continued to push forward the upgrade of efforts for the operational pain points of dealers in 2022. This helped dealers increase their control over the overall organization and operation while continuously improving their management abilities.</br>SAIC VOLKSWAGEN has launched personalized coaching programs focusing on various areas such as CAE lead generation, RSE retail excellence, and value-added business capacity enhancement. The programs are designed to help dealers explore their own potential, achieve a higher rate of lead generation and conversion, and expand their private domain traffic pool. At the same time, their online operation and maintenance capabilities will be elevated, thereby improving their management efficiency. In 2022, the Company conducted more than 1,000 coaching sessions in total.",
        },
        {
          title: "门店展厅升级",
          titleEn: "Upgrading of store showrooms",
          dec:
            "上汽大众持续推动数字化展厅升级，提高消费者服务水平，提高品牌可持续性创造力。围绕“Go to Zero”的节能环保理念，2022年，公司持续开展经销商展厅的升级改造工作，将大面积使用LED灯源替代了原来大功率的金属卤素照明灯，在营造舒适安逸的购车环境的同时为经销商节约了25%的照明电能。",
          decEn:
            "SAIC VOLKSWAGEN continuously carries out digital showroom upgrades to improve consumer service levels and enhance the brand’s sustainability and creativity. Focusing on the concept of “Go to Zero”, in 2022, the Company carried out the upgrade of dealership showrooms and replaced the original high-powered metal halide lighting with LED lighting sources, thus saving 25% of lighting electricity for dealers while creating a comfortable and relaxing environment for car shopping.",
        },
        {
          title: "新能源“店中店”个性化专区",
          titleEn: "New energy “Shop-in-Shop” personalized zone",
          dec:
            "项目采用个性化专区布局，成功打造新能源车虚拟“店中店”营销场景。该项目同时构建富有科技感与未来感的新能源特性展厅，通过独特的装修与展示风格传递核心科技理念，有效提高服务质量，创造出模块化的ID.车型展示区，科技感和新能源特性十足。",
          decEn:
            "As an important part of SAIC VOLKSWAGEN’s electrification strategy, the 2022 New Energy “Shop-in-Shop” project was officially launched, with a personalized zone arrangement. The project also featured a new energy showroom with a high-tech design and futuristic features, conveying core technology concepts through unique decorations and display styles. It has effectively enhanced the quality of service and created a modular ID. model display area with a high-tech vibe and new energy features. ",
        },
       
      ],
    },
  ],
};
